<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="pa-0 ma-0">
          <v-tabs
            vertical
          >
            <v-tab>
              {{ $t('product') }}
            </v-tab>
            <v-tab align="right">
              {{ $t('customer') }}
            </v-tab>
            <v-tab align="right">
              {{ $t('invoice') }}
            </v-tab>
            <v-tab align="right">
              {{ $t('payment') }}
            </v-tab>
            <v-tab-item>
              <v-container>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookProductStore"
                    :label="$t('store') + ' ' + $t('product')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookProductEdit"
                    :label="$t('edit') + ' ' + $t('product')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookProductRemove"
                    :label="$t('remove') + ' ' + $t('product')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookProductChangeStock"
                    :label="$t('changeProductStock')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookProductChangePrice"
                    :label="$t('changeProductPrice')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container
                class="pt-0"
                fluid
              >
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookCustomerStore"
                    :label="$t('store') + ' ' + $t('customer')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookCustomerEdit"
                    :label="$t('edit') + ' ' + $t('customer')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookCustomerRemove"
                    :label="$t('remove') + ' ' + $t('customer')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container
                class="pt-0"
                fluid
              >
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookInvoiceStore"
                    :label="$t('store') + ' ' + $t('invoice')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookInvoiceEdit"
                    :label="$t('edit') + ' ' + $t('invoice')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookInvoiceRemove"
                    :label="$t('remove') + ' ' + $t('invoice')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookPaymentStore"
                    :label="$t('store') + ' ' + $t('payment')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookPaymentEdit"
                    :label="$t('edit') + ' ' + $t('payment')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookPaymentRemove"
                    :label="$t('remove') + ' ' + $t('payment')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="webhookPosPayment"
                    :label="$t('submit-payment-with-pos')"
                    outlined
                    placeholder="https://..."
                    clearable
                    dense
                  />
                </v-col>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
// import autocomplete from '../../components/general/patial/autocomplete'
import General from '../../../../Mixins/general'
export default {
  name: 'Customer',
  components: {
    // aicomplete,
    // autocomplete,
  },
  mixins: [General],
  data: () => ({
    valid: true,
    webhookProductStore: null,
    webhookProductEdit: null,
    webhookProductRemove: null,
    webhookProductChangeStock: null,
    webhookProductChangePrice: null,
    webhookCustomerStore: null,
    webhookCustomerEdit: null,
    webhookCustomerRemove: null,
    webhookInvoiceStore: null,
    webhookInvoiceEdit: null,
    webhookInvoiceRemove: null,
    webhookPaymentStore: null,
    webhookPaymentEdit: null,
    webhookPaymentRemove: null,
    webhookPosPayment: null,
    type: null,
    render: false,
    isLoading: false
  }),
  watch: {
  },
  activated () {
    this.show()
  },
  beforeMount () {
  },
  mounted () {
    this.show()
  },
  methods: {
    remove (index) {
      this.paymentItems.splice(index, 1)
    },
    create () {
      var app = this
      app.isLoading = true
      app.$axios.post(this.$endpoint + 'webhook', this.$data)
        .then(res => {
          app.snakbarText = app.$t('registered')
          app.snakbarColor = 'green'
          app.snakbar = true
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    show () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'webhook', {
        params: {
        }
      })
        .then(res => {
          app.$nextTick(() => {
            res = res.data
            app.webhookProductStore = res.webhookProductStore
            app.webhookProductEdit = res.webhookProductEdit
            app.webhookProductRemove = res.webhookProductRemove
            app.webhookProductChangeStock = res.webhookProductChangeStock
            app.webhookProductChangePrice = res.webhookProductChangePrice
            app.webhookCustomerStore = res.webhookCustomerStore
            app.webhookCustomerEdit = res.webhookCustomerEdit
            app.webhookCustomerRemove = res.webhookCustomerRemove
            app.webhookInvoiceStore = res.webhookInvoiceStore
            app.webhookInvoiceEdit = res.webhookInvoiceEdit
            app.webhookInvoiceRemove = res.webhookInvoiceRemove
            // payment
            app.webhookPaymentStore = res.webhookPaymentStore
            app.webhookPaymentEdit = res.webhookPaymentEdit
            app.webhookPaymentRemove = res.webhookPaymentRemove
            app.webhookPosPayment = res.webhookPosPayment

            app.render = true
          })
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }
}
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
